export const CONTACT_NOT_IN_CRM_COPY =
  'Contact not in CRM — cannot update this reminder.';

const ACTIONABLE_TYPES = new Set(['scheduled_message', 'follow_up']);
const HIDDEN_SOURCE_STATUSES = new Set(['completed', 'cancelled', 'failed']);

export function isFollowUpReminder(item) {
  return ACTIONABLE_TYPES.has(item?.type);
}

export function getReminderContactId(item) {
  const id = item?.contact?.id;
  if (id == null || id === '') return null;
  return id;
}

export function getReminderSourceId(item) {
  const n = Number(item?.source_id);
  if (!Number.isInteger(n) || n <= 0) return null;
  return n;
}

export function canUpdateReminder(item) {
  return (
    isFollowUpReminder(item) &&
    getReminderContactId(item) != null &&
    getReminderSourceId(item) != null
  );
}

export function shouldShowContactMissing(item) {
  return isFollowUpReminder(item) && getReminderContactId(item) == null;
}

/**
 * Buttons from meta.schedule_type + source_status only.
 * Do not use list status (upcoming / overdue).
 */
export function actionsForReminder(item) {
  const type = item?.meta?.schedule_type || item?.meta?.follow_up_type;
  const s = item?.source_status;

  if (HIDDEN_SOURCE_STATUSES.has(s)) return [];

  if (type === 'scheduled') {
    if (s === 'scheduled') return ['stop', 'reschedule'];
    if (s === 'stopped') return ['reschedule'];
    return [];
  }

  if (type === 'yearly_date') {
    if (s === 'active') return ['stop'];
    return [];
  }

  if (type === 'interval') {
    if (s === 'active') return ['pause'];
    if (s === 'paused') return ['resume'];
    return [];
  }

  return [];
}

export function getReminderActionButtons(item) {
  if (!canUpdateReminder(item)) return [];
  return actionsForReminder(item);
}
